//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "flop",
  data: function data() {
    return {
      active: 0,
      statusDIC: [".", ","]
    };
  },
  computed: {
    isArray: function isArray() {
      return Array.isArray(this.dataChart);
    },
    decimals: function decimals() {
      return this.option.decimals || 0;
    },
    listData: function listData() {
      if (this.isArray) {
        return this.dataChart;
      } else {
        return [this.dataChart];
      }
    },
    isWhole: function isWhole() {
      return this.vaildData(this.option.whole, false);
    },
    type: function type() {
      return this.option.type;
    },
    isBorder: function isBorder() {
      return this.type === 'border';
    },
    isImg: function isImg() {
      return this.type === 'img';
    },
    span: function span() {
      return this.option.span || 1;
    },
    prefixStyle: function prefixStyle() {
      return {
        display: this.option.prefixInline ? 'inline-block' : 'block',
        textAlign: this.option.prefixTextAlign,
        marginBottom: this.setPx(this.option.prefixSplity),
        marginRight: this.setPx(this.option.prefixSplitx),
        color: this.option.prefixColor || "#fff",
        fontSize: this.setPx(this.option.prefixFontSize || 24)
      };
    },
    suffixStyle: function suffixStyle() {
      return {
        display: this.option.suffixInline ? 'inline-block' : 'block',
        textAlign: this.option.suffixTextAlign,
        marginTop: this.setPx(this.option.suffixSplity),
        marginLeft: this.setPx(this.option.suffixSplitx),
        color: this.option.suffixColor || "#fff",
        fontSize: this.setPx(this.option.suffixFontSize || 24)
      };
    },
    styleParentSize: function styleParentSize() {
      var obj = {
        boxSizing: 'border-box',
        display: 'inline-block',
        width: 100 / this.span - 1 + '%'
      };

      if (this.option.splitx) {
        obj.paddingRight = this.setPx(this.option.splitx);
      }

      if (this.option.splity) {
        obj.paddingBottom = this.setPx(this.option.splity);
      }

      return obj;
    },
    styleParentName: function styleParentName() {
      var obj = {};

      if (!this.isImg && !this.isBorder) {
        obj = Object.assign(obj, {
          backgroundImage: "url(".concat(this.option.backgroundImage, ")"),
          backgroundColor: this.option.backgroundColor
        });
      }

      if (this.option.padding) {
        obj.padding = this.setPx(this.option.padding);
      }

      return obj;
    },
    styleName: function styleName() {
      var _this = this;

      return Object.assign(function () {
        var obj = {};

        if (_this.option.splitx) {
          obj.marginRight = _this.setPx(_this.option.splitx);
        }

        if (_this.option.splity) {
          obj.marginBottom = _this.setPx(_this.option.splity);
        }

        if (_this.option.backgroundImage) {
          obj = Object.assign(obj, {
            backgroundImage: "url(".concat(_this.option.backgroundImage, ")"),
            backgroundSize: "100% 100%"
          });
        }

        return obj;
      }(), {
        textAlign: this.option.textAlign,
        backgroundColor: this.option.backgroundColor,
        color: this.option.color || "#fff",
        fontSize: this.setPx(this.option.fontSize || 64),
        fontWeight: this.option.fontWeight
      }, function () {
        if (_this.type === "img") {
          return {
            borderImageSource: "url(".concat(_this.option.backgroundBorder, ")")
          };
        } else if (_this.type === "border") {
          return {
            borderColor: _this.option.borderColor || "#fff",
            borderStyle: "solid",
            borderWidth: _this.setPx(_this.option.borderWidth)
          };
        }
      }());
    }
  },
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {},
  methods: {
    handleClick: function handleClick(item, index) {
      this.active = index;
      this.updateClick({
        value: item.prefixText
      });
      this.clickFormatter && this.clickFormatter({
        type: index,
        item: item,
        value: item.prefixText,
        data: this.dataChart
      }, this.getItemRefs());
      if (item.href) window.open(item.href, item.target);
    },
    getEmpStyle: function getEmpStyle(index) {
      var result = {};

      if (index == this.active) {
        result = {
          color: this.option.empColor
        };
      }

      return result;
    },
    getValByArray: function getValByArray(item, prop) {
      return this.isArray ? item[prop] : this.option[prop];
    }
  }
});